import { CommentDialogState } from ".";
import { Interface } from "../../interface-definitions";

export const CommentDialogInitialState: CommentDialogState = {
  commentDescription: "",
  selectedEvent: "",
  ifList: {} as Interface,
  isShow: false,
  isSaved: true,
  formValidation: true,
  fieldPath: {
    cmnt: "cmnt",
  },
  onChangeSpreadsheetState: () => {},
};
